'use strict';

var recaptcha = require('core/components/recaptcha');

/**
 * Display the returned message.
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for contact us sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.contact-us-signup-message').length === 0) {
        $('body').append(
            '<div class="contact-us-signup-message"></div>'
        );
    }
    $('.contact-us-signup-message')
        .append('<div class="contact-us-signup-alert text-center ' + status + '" role="alert">' + data.msg + '</div>');

    setTimeout(function () {
        $('.contact-us-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

module.exports = {
    subscribeContact: function () {
        $('form.trade-program').submit(function (e) {
            e.preventDefault();
            var formData = new FormData(this);
            var form = $(this);
            var button = $('.subscribe-trade-program');
            var url = form.attr('action');

            $.spinner().start();
            button.attr('disabled', true);
            $.ajax({
                url: url,
                type: 'POST',
                data: formData,
                success: function (data) {
                    displayMessage(data, button);
                    if (data.success) {
                        $('.trade-program').trigger('reset');
                    }
                    if (data.email) {
                        $('body').trigger('gtm:pushData', {
                            event: 'identify',
                            userData: {
                                customerEmail: data.email
                            }
                        });
                    }
                },
                cache: false,
                contentType: false,
                processData: false,
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                    displayMessage(err, button);
                }
            });
        });
    },
    formAutoFill: function () {
        var siteIntegrations = require('integrations/integrations/siteIntegrationsUtils');
        var toggleObject = siteIntegrations.getIntegrationSettings();

        if(toggleObject.googlePlacesEnabled) {
            var googleAutoComplete = require('../thirdParty/googleAutoComplete');
            googleAutoComplete.initAutocomplete();
        }
    }
};
